module.exports = __webpack_public_path__ + "static/media/result-1-en.87be55b3.png";